function initCustomReviews() {
  const $reviewsSection = $(".reviews").first();

  if (!$reviewsSection.length) {
    console.warn("[customReviews] Nenalezen blok .reviews.");
    return;
  }

  if ($reviewsSection.data("customReviewsInitialized")) {
    return;
  }

  $reviewsSection.data("customReviewsInitialized", true);

  const storageKey = "storeRatingData-" + document.location.host;

  const primaryUrl = "/hodnoceni-obchodu/?jsonFormat";
  const fallbackUrl = "/hodnoceni-obchodu/";

  const DEBUG_REVIEWS = false;

  function reviewLog(...args) {
    if (DEBUG_REVIEWS) {
      console.log("[customReviews]", ...args);
    }
  }

  function reviewWarn(...args) {
    if (DEBUG_REVIEWS) {
      console.warn("[customReviews]", ...args);
    }
  }

  function safeParseJson(data) {
    try {
      if (typeof data === "string") {
        const trimmedData = data.trim();

        if (!trimmedData) {
          reviewWarn("Response je prázdný string.");
          return null;
        }

        reviewLog("Zkouším JSON.parse(), délka stringu:", trimmedData.length);

        return JSON.parse(trimmedData);
      }

      if (typeof data === "object" && data !== null) {
        reviewLog("Response už je objekt:", data);
        return data;
      }

      reviewWarn("Response není string ani objekt:", typeof data, data);

      return null;
    } catch (error) {
      reviewWarn("Nevalidní JSON:", error);
      return null;
    }
  }

  function normalizeRatingData(data) {
    if (!data || typeof data !== "object") {
      return null;
    }

    const averageScore = parseFloat(
      String(data.averageScore ?? "")
        .replace(",", ".")
        .trim(),
    );

    const count = parseInt(data.count, 10);

    const ratings = Array.isArray(data.ratings)
      ? data.ratings.map(function (rating) {
          return {
            fullName: rating && rating.fullName != null ? String(rating.fullName).trim() : "",

            score: rating && Number.isFinite(parseFloat(rating.score)) ? parseFloat(rating.score) : 0,

            description: rating && rating.description != null ? String(rating.description).replace(/\s+/g, " ").trim() : "",
          };
        })
      : [];

    if (!Number.isFinite(averageScore) || !Number.isFinite(count) || !Array.isArray(ratings)) {
      return null;
    }

    return {
      averageScore: averageScore,
      count: count,
      ratings: ratings,
    };
  }

  function isValidRatingData(data) {
    const normalizedData = normalizeRatingData(data);

    const isValid = normalizedData !== null && Number.isFinite(normalizedData.averageScore) && Number.isFinite(normalizedData.count) && Array.isArray(normalizedData.ratings);

    reviewLog("Validace dat:", isValid, normalizedData);

    return isValid;
  }

  function parseRatingHtml(html) {
    reviewLog("Spouštím parseRatingHtml()");
    reviewLog("Typ HTML response:", typeof html);

    if (typeof html !== "string") {
      reviewWarn("HTML parser nedostal string:", html);
      return null;
    }

    reviewLog("HTML response délka:", html.length);
    reviewLog("HTML response začátek:", html.substring(0, 500));

    const $html = $("<div>").html(html);

    reviewLog("Počet nalezených #ratingWrapper:", $html.find("#ratingWrapper").length);

    reviewLog("Počet nalezených #ratingsList:", $html.find("#ratingsList").length);

    reviewLog("Počet nalezených .vote-wrap:", $html.find("#ratingsList .vote-wrap").length);

    const $ratingWrapper = $html.find("#ratingWrapper").first();

    if (!$ratingWrapper.length) {
      reviewWarn("Nenalezen #ratingWrapper, parser vrací null.");
      return null;
    }

    const averageText = $ratingWrapper.find(".rate-average").first().text().trim();

    reviewLog("averageText:", averageText);

    const averageScore = parseFloat(averageText.replace(",", ".").replace(/[^\d.]/g, "")) || 0;

    reviewLog("averageScore:", averageScore);

    const countText = $ratingWrapper.find(".stars-label").first().text().trim();

    reviewLog("countText:", countText);

    const count = parseInt(countText.replace(/[^\d]/g, ""), 10) || 0;

    reviewLog("count:", count);

    const ratings = $html
      .find("#ratingsList .vote-wrap")
      .slice(0, 4)
      .map(function (index) {
        const $item = $(this);

        const fullName = $item.find('[data-testid="textRatingAuthor"] span').first().text().trim();

        const description = $item.find('[data-testid="textRating"]').first().text().replace(/\s+/g, " ").trim();

        const score = $item.find('[data-testid="gridStars"] .star-on').length;

        const itemData = {
          fullName: fullName || "",
          score: score || 0,
          description: description || "",
        };

        reviewLog("Rating položka #" + (index + 1) + ":", itemData);

        return itemData;
      })
      .get();

    const parsedData = {
      averageScore: averageScore,
      count: count,
      ratings: ratings,
    };

    reviewLog("Výsledek parseRatingHtml():", parsedData);

    return parsedData;
  }

  function generateStars(score) {
    const normalizedScore = Math.max(0, Math.min(5, parseFloat(score) || 0));

    const fullStars = Math.floor(normalizedScore);

    const hasHalfStar = normalizedScore % 1 >= 0.5 && fullStars < 5;

    let starsHtml = "";
    let renderedStars = 0;

    for (let i = 0; i < fullStars; i++) {
      starsHtml += '<span class="star star-on" aria-hidden="true"></span>';

      renderedStars++;
    }

    if (hasHalfStar) {
      starsHtml += '<span class="star star-half" aria-hidden="true"></span>';

      renderedStars++;
    }

    for (let i = renderedStars; i < 5; i++) {
      starsHtml += '<span class="star star-off" aria-hidden="true"></span>';
    }

    return starsHtml;
  }

  function escapeReviewHtml(value) {
    return $("<div>")
      .text(value == null ? "" : String(value))
      .html();
  }

  function renderRating(data) {
    reviewLog("Spouštím renderRating()", data);

    const parsedData = typeof data === "string" ? safeParseJson(data) : data;

    const normalizedData = normalizeRatingData(parsedData);

    if (!normalizedData) {
      reviewWarn("Data hodnocení nejsou validní:", data);
      return;
    }

    const average = normalizedData.averageScore;
    const count = normalizedData.count;
    const ratings = normalizedData.ratings.slice(0, 4);

    const reviewHtml = ratings
      .map(function (rating) {
        const fullName = rating.fullName || (typeof translation === "function" ? translation("overenyZakaznik") : "Ověřený zákazník");

        return `
          <div class="review-item">
            <div class="header">
              <div class="review-name">
                ${escapeReviewHtml(fullName)}
              </div>

              <div class="review-stars">
                <span class="stars">
                  ${generateStars(rating.score)}
                </span>
              </div>
            </div>

            <div class="review-description">
              ${escapeReviewHtml(rating.description)}
            </div>
          </div>
        `;
      })
      .join("");

    $reviewsSection.find(".reviewsNumbers .topNumber").text(average.toFixed(1).replace(".", ","));

    $reviewsSection.find(".reviewsNumbers .count").text(count);

    $reviewsSection.find(".reviewsNumbers > .stars").html(generateStars(average));

    $reviewsSection.find(".wrapper > .right").html(reviewHtml);

    $reviewsSection.addClass("reviews-loaded");

    reviewLog("Render dokončen.", {
      average: average,
      count: count,
      ratingsCount: ratings.length,
    });
  }

  function saveRatingData(data) {
    const normalizedData = normalizeRatingData(data);

    if (!normalizedData) {
      reviewWarn("Nelze uložit nevalidní data:", data);
      return false;
    }

    try {
      sessionStorage.setItem(storageKey, JSON.stringify(normalizedData));

      reviewLog("Data byla uložena do sessionStorage:", storageKey, normalizedData);

      return true;
    } catch (error) {
      reviewWarn("Nepodařilo se uložit data do sessionStorage:", error);

      return false;
    }
  }

  function loadRatingFromUrl(url, onFail) {
    reviewLog("Načítám URL:", url);

    $.ajax({
      url: url,
      method: "GET",
      cache: false,

      headers: {
        "X-Store-Rating-Details": "true",
      },

      success: function (response, textStatus, xhr) {
        reviewLog("AJAX success:", url);
        reviewLog("HTTP status:", xhr.status);
        reviewLog("Content-Type:", xhr.getResponseHeader("content-type"));
        reviewLog("Typ response:", typeof response);
        reviewLog("Response:", response);

        let parsedData = safeParseJson(response);

        reviewLog("Po safeParseJson:", parsedData);

        if (!isValidRatingData(parsedData)) {
          reviewLog("JSON není validní, zkouším HTML parser.");

          const htmlResponse = typeof response === "string" ? response : xhr.responseText;

          parsedData = parseRatingHtml(htmlResponse);
        }

        reviewLog("Po HTML parseru:", parsedData);

        const normalizedData = normalizeRatingData(parsedData);

        if (normalizedData) {
          reviewLog("Data jsou validní, ukládám je a renderuji.");

          saveRatingData(normalizedData);
          renderRating(normalizedData);

          return;
        }

        reviewWarn("Nepodařilo se získat validní data hodnocení:", url, response);

        if (typeof onFail === "function") {
          reviewLog("Spouštím fallback callback.");
          onFail();
        }
      },

      error: function (xhr, status, error) {
        reviewWarn("AJAX error:", {
          url: url,
          status: status,
          error: error,
          httpStatus: xhr.status,
          responseText: xhr.responseText,
        });

        if (typeof onFail === "function") {
          reviewLog("Spouštím fallback callback po AJAX erroru.");

          onFail();
        }
      },
    });
  }

  let storedData = null;

  try {
    storedData = sessionStorage.getItem(storageKey);
  } catch (error) {
    reviewWarn("Nepodařilo se načíst sessionStorage:", error);
  }

  reviewLog("Data v sessionStorage:", storedData);

  const parsedStoredData = safeParseJson(storedData);
  const normalizedStoredData = normalizeRatingData(parsedStoredData);

  if (normalizedStoredData) {
    reviewLog("Používám data ze sessionStorage.");
    renderRating(normalizedStoredData);

    return;
  }

  reviewLog("sessionStorage není validní, mažu data a načítám je z URL.");

  try {
    sessionStorage.removeItem(storageKey);
  } catch (error) {
    reviewWarn("Nepodařilo se odstranit sessionStorage:", error);
  }

  loadRatingFromUrl(primaryUrl, function () {
    reviewLog("Primary URL selhala, načítám fallback URL.");

    loadRatingFromUrl(fallbackUrl);
  });
}

$(function () {
  initCustomReviews();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
  initCustomReviews();
});
